var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.ids),function(item,index){return _c('el-image',{staticClass:"pic",style:({width:(_vm.width + "px"),height:(_vm.height + "px")}),attrs:{"src":_vm.imgUrl2+"" + (item.id?item.id:item.Id),"preview-src-list":_vm.imgs}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }